import {
  ExternalAccountView,
  Template,
} from '@app/queryTyping';

/**
 * Check if it is external account,
 * by checking availability of specific property.
 */
export const isExternalAccount = (account: any): account is ExternalAccountView => (
  !!account && typeof (account as ExternalAccountView).institutionName !== 'undefined'
);

export const isBusinessBankingTemplate = (account: any): account is Template => (
  !!account && typeof (account as Template).commercialBankingCategory !== 'undefined'
);
